import type { UUID } from '@cmg/common';
import { useCallback } from 'react';

import type { CrmManagement_InvestorFirmsQueryVariables } from '../../../graphql/__generated__';
import {
  useCrmManagement_AdminInvestorFirmsLazyQuery,
  useCrmManagement_InvestorFirmsLazyQuery,
} from '../../../graphql/__generated__';

export function useInvestorFirmsQuery(tenantId?: UUID) {
  const [loadRowsCustomer] = useCrmManagement_InvestorFirmsLazyQuery();
  const [loadRowsAdmin] = useCrmManagement_AdminInvestorFirmsLazyQuery();

  return useCallback(
    async (variables: CrmManagement_InvestorFirmsQueryVariables) => {
      if (tenantId) {
        const response = await loadRowsAdmin({
          variables: {
            ...variables,
            tenantId,
          },
          fetchPolicy: 'no-cache',
        });

        return {
          ...response,
          data: {
            ...response.data,
            investorFirmsGrid: response.data?.adminInvestorFirmsGrid,
          },
        };
      } else {
        return await loadRowsCustomer({
          variables,
          fetchPolicy: 'no-cache',
        });
      }
    },
    [loadRowsAdmin, loadRowsCustomer, tenantId]
  );
}
